<ng-container *ngIf="initialized">
  <form class="form" #myForm="ngForm" (ngSubmit)="onSave()" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="certification.id" class="modal-title" id="exampleModalLabel">Edit Certification</h5>
        <h5 *ngIf="!certification.id" class="modal-title" id="exampleModalLabel">Add Certification</h5>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <div class="row">
          <div class="col">
            <h6>Certification Body</h6>
            <div class="form-group">
              <select class="form-control" [disabled]="certification.id != null || lockTocertificationBodyId != null"  required [(ngModel)]="certification.certificationBodyId" [compareWith]="compare" name="certificationBody">
                <option value="">Please Choose...</option>
                <option *ngFor="let item of bodies" value="{{ item.id }}">{{ item.name }}</option>
              </select>

              <div class="invalid-message">
                <div>Certification Body is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h6>Certification Number:</h6>
            <div class="form-group">
              <input type="text" class="form-control" required [(ngModel)]="certification.certificationNumber" name="ceuProviderCode" />

              <div class="invalid-message">
                <div>Certification number is required</div>
              </div>
              <small class="">If this is for a Certificate of attendance, you can put any value in this field and it will show on the certificate.</small>

            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-admin-primary mr-2"  [promiseBtn]="submitComplete" type="submit">
              <span *ngIf="!certification.id">Add</span>
              <span *ngIf="certification.id">Update</span>
            </button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
